import { UDV_PLANS } from './constants'

/** Etiqueta corta en chrome (barra superior). */
const PLAN_DISPLAY_LABELS = {
  [UDV_PLANS.PATIENT]: 'PACIENTE',
  [UDV_PLANS.DEMO]: 'DEMO',
  [UDV_PLANS.LITE]: 'LITE',
  [UDV_PLANS.PRO]: 'PRO',
  [UDV_PLANS.PREMIUM]: 'PREMIUM',
  [UDV_PLANS.SUPREMO]: 'SUPREMO',
}

/**
 * @param {string|null|undefined} plan
 * @returns {string}
 */
export function getPlanDisplayLabel(plan) {
  if (plan == null || plan === '') return 'UDV'
  const key = String(plan).toLowerCase()
  if (PLAN_DISPLAY_LABELS[key]) return PLAN_DISPLAY_LABELS[key]
  return String(plan).toUpperCase()
}
